<template>
  <el-menu
    :default-active="defaultActive"
    class="menu"
    active-text-color="#1D87C9"
    @select="handleSelect"
  >
    <el-menu-item
      index="journey_actions"
      v-if="model.workflow && $hasFeature('journeyBuilderCampaignAnalytics')"
    >
      <template #title>
        <icon glyph="campaign-multistage" />
        <span>{{ $t('CampaignAnalytics_JourneyActions_Title') }}</span>
      </template>
    </el-menu-item>
    <el-menu-item v-if="model.ab" index="variants">
      <template #title>
        <icon glyph="variant-testing" />
        <span>{{ $t('CampaignAnalytics_Sidebar_Variant_Testing_Tab') }}</span>
      </template>
    </el-menu-item>
    <el-menu-item index="all_channels">
      <template #title>
        <icon glyph="channel" />
        <span>{{ $t('CampaignAnalytics_Sidebar_AllChannels') }}</span>
      </template>
    </el-menu-item>
    <el-submenu v-for="channel in channels" :key="channel" :index="channel">
      <template #title>
        <icon :glyph="`dashboard_${channel}`" />
        <span>{{ $t(`CampaignAnalytics_Channel_${channel}`) }}</span>
      </template>
      <el-menu-item :index="`${channel}_summary`">
        {{ $t('CampaignAnalytics_Sidebar_Summary_Tab') }}
      </el-menu-item>
      <el-menu-item v-if="model.ab" :index="`${channel}_variant_testing`">
        {{ $t('CampaignAnalytics_Sidebar_Variant_Testing_Tab') }}
      </el-menu-item>
      <el-menu-item
        v-if="clickedLinksSupported(channel)"
        :index="`${channel}_clicked_links`"
      >
        {{ $t('CampaignAnalytics_Sidebar_Clicked_Links_Sidebar_Tab') }}
      </el-menu-item>
      <el-menu-item
        v-if="clickMapsSupported(channel)"
        :index="`${channel}_click_map`"
      >
        {{ $t('CampaignAnalytics_Sidebar_Click_Map_Sidebar_Tab') }}
      </el-menu-item>
      <el-menu-item
        v-if="interactionsSupported(channel)"
        :index="`${channel}_interactions`"
      >
        {{ $t('CampaignAnalytics_Sidebar_Interactions_Sidebar_Tab') }}
      </el-menu-item>
      <el-menu-item v-if="channel === 'email'" :index="`${channel}_domains`">
        {{ $t('CampaignAnalytics_Sidebar_Domains_Sidebar_Tab') }}
      </el-menu-item>
      <el-menu-item
        v-if="deliveryFailuresSupported(channel)"
        :index="`${channel}_delivery_failures`"
      >
        {{ $t('CampaignAnalytics_Sidebar_Delivery_Sidebar_Tab') }}
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
import { MessageTypeEnum } from '@/common/enum/MessageTypeEnum'

export default {
  name: 'AnalyticsSidebar',
  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      allSupportedChannels: [
        'email',
        'mobile_push',
        'sms',
        'web_push',
        'inapp',
        'onsite',
        'inbox'
      ],
      MessageTypeEnum
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$emit('select', { key: key, keyPath: keyPath })
    },

    clickedLinksSupported(channel) {
      const supportedChannels = ['email', 'sms']
      return supportedChannels.includes(channel)
    },

    clickMapsSupported(channel) {
      return (
        channel === 'email' &&
        (!this.model.workflow ||
          this.$store.state.app.features.workflowClickmap)
      )
    },

    interactionsSupported(channel) {
      const supportedChannels = ['onsite', 'inapp', 'mobile_push', 'web_push']
      return supportedChannels.includes(channel)
    },

    deliveryFailuresSupported(channel) {
      return this.allSupportedChannels.includes(channel)
    }
  },

  computed: {
    channels() {
      let channels = this.allSupportedChannels.filter(
        ch => (this.model[ch] || 0) === 1
      )
      if (this.model.ios_push || this.model.android_push) {
        channels.push('mobile_push')
      }

      return channels
    },

    defaultActive() {
      if (this.model.workflow) {
        return 'journey_actions'
      }

      return 'all_channels'
    }
  }
}
</script>

<style scoped>
.menu {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/analytics/AnalyticsSidebar.vue